module.exports = __webpack_public_path__ + "static/media/logo-parceiro-soft.3913667c.webp";